import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer-new">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="brand-link">
              <img src="/images/logofav.png" alt="DOMOELEC" />
              
            </Link>
            <p>Solutions de courant faible: détection incendie, éclairage de sécurité, contrôle d'accès, onduleurs.</p>
            <div className="socials">
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
              <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
              <a href="#" aria-label="X"><i className="fab fa-twitter"></i></a>
            </div>
          </div>

          <nav className="footer-nav">
            <div className="col">
              <h4>Navigation</h4>
              <ul>
                <li><Link to="/domoelec">À propos</Link></li>
                <li><Link to="/produits">Produits</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>
            <div className="col">
              <h4>Services</h4>
              <ul>
                <li><Link to="/services#installation">Installation</Link></li>
                <li><Link to="/services#maintenance">Maintenance</Link></li>
                <li><Link to="/services#controle">Contrôle & Vérification</Link></li>
                <li><Link to="/services#conseil">Conseil & Études</Link></li>
              </ul>
            </div>
            <div className="col">
              <h4>Contact</h4>
              <ul className="contact-lines">
                <li><i className="fas fa-phone"></i> 05 22 34 06 59</li>
                <li><i className="fas fa-envelope"></i> contact@domoelec.ma</li>
                <li><i className="fas fa-map-marker-alt"></i> 47 Rue Des Orangers, Mag Res Eden Tower, Ain Sebaa - Casablanca</li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="footer-bottom-new">
          <p>© {new Date().getFullYear()} DOMOELEC. Tous droits réservés. Design by 3SPROTECH </p>
          <div className="links">
            <Link to="/mentions-legales">Mentions légales</Link>
            <Link to="/politique-confidentialite">Confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
